/* GlowVital — Premium interactions. Runs only on pages with .gv-premium. */
(function(){
  if(window.__gvPremiumInit) return;
  window.__gvPremiumInit = true;
  if(!document.querySelector('.gv-premium')) return;

  // Scroll reveal
  var reveals = document.querySelectorAll('.gv-reveal');
  if(reveals.length && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, {threshold: 0.12});
    reveals.forEach(function(el){ io.observe(el); });
  }

  // Sticky mobile ATC: show only after scroll past hero on product pages
  var sticky = document.querySelector('.gv-sticky-atc');
  if(sticky){
    document.body.classList.add('has-sticky-atc');
  }
})();

/* Testimonials: uniform-height clamp + read-more toggle.
   Separate IIFE so it runs on any page that includes premium.js, regardless
   of whether a .gv-premium wrapper is present. Runs once per element and is
   safe against re-entry (e.g. when Swiper clones slides for loops). */
(function(){
  if(window.__gvTmInit) return;
  window.__gvTmInit = true;

  function wireTestimonials(){
    var els = document.querySelectorAll('div[class^="testimonials-slide-text-"], div[class*=" testimonials-slide-text-"]');
    els.forEach(function(el){
      if(el.dataset.gvTm) return;
      el.dataset.gvTm = '1';

      var isTruncated = el.scrollHeight > el.clientHeight + 2;
      if(!isTruncated) return;

      var btn = document.createElement('button');
      btn.className = 'gv-tm-more';
      btn.type = 'button';
      btn.textContent = 'Read more';
      btn.addEventListener('click', function(ev){
        ev.stopPropagation();
        var expanded = el.classList.toggle('gv-tm-expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
      if(el.parentNode){
        el.parentNode.insertBefore(btn, el.nextSibling);
      }
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', wireTestimonials);
  } else {
    wireTestimonials();
  }
  // Re-scan after Swiper / lazy init finishes
  setTimeout(wireTestimonials, 600);
  setTimeout(wireTestimonials, 1800);
})();
